module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"react","commonjs":"react","amd":"react","umd":"react","root":"_"}
// module id = 1
// module chunks = 0 1 2 3 4 5